<template>
  <div>
    <el-card v-if="errors.email && errors.email.length">
      <el-alert
        v-for="error in errors.email"
        :key="error"
        :closable="false"
        show-icon
        :title="error"
        type="error"
      />
    </el-card>

    <el-form-item
      for="email"
      label="E-Mail-Adresse"
      prop="email"
    >
      <el-input
        id="email"
        v-model="form.email"
        type="email"
      />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'CAccountFormAccount',

  props: {
    form: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    }
  }
}
</script>
